// Module
var code = "<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">×</button>\n  <h3>{{modal.title}}</h3>\n</div>\n<div class=\"modal-body\">\n\n  <div ng-bind-html=\"modal.body\"></div>\n\n</div>\n<div class=\"modal-footer\">\n  <button type=\"button\" class=\"btn btn-danger\" ng-click=\"dismiss()\">Close</button>\n</div>";
// Exports
var _module_exports =code;;
var path = 'public/app/partials/modal.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;